// @ts-check
/**
 * Typed client for Hermes templates.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios';

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['HermesProgram']} HermesProgram */
/** @typedef {Schemas['HermesTemplateKindEnum']} HermesTemplateKind */

/**
 * A template that writes one care management document onto an engagement (HermesTemplate.Kind.DOCUMENT).
 * @type {HermesTemplateKind}
 */
export const DOCUMENT_KIND = 'document';

const BASE = '/api/hermes/templates';

/**
 * GET /api/hermes/templates/programs/ — the care management programs a document template can be limited to,
 * sorted by name.
 * @returns {Promise<HermesProgram[]>}
 */
export async function listPrograms() {
  const { data } = await axios.get(`${BASE}/programs/`);
  return data;
}
